import React, { useState } from "react";
import { X, Images } from "lucide-react";
import { fileUrl } from "../lib/api";

export default function GallerySection({ items, content }) {
  const [active, setActive] = useState(null);
  const sorted = [...(items || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const loop = sorted.length > 0 && sorted.length < 8 ? [...sorted, ...sorted] : sorted;
  return (
    <section id="gallery" data-testid="gallery-section" className="py-16 md:py-20 bg-[#0f0807] border-t border-[#F0E8DB]/10 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 text-center mb-10">
        <div className="text-[#F0E8DB] text-xs tracking-[0.4em] font-serif-en mb-3">GALLERY</div>
        <h2 className="section-title text-3xl sm:text-4xl">{content.titles.gallery}</h2>
        {content.gallery_intro && <p className="text-[#A89A88] mt-3 text-sm">{content.gallery_intro}</p>}
      </div>

      {sorted.length === 0 ? (
        <div data-testid="gallery-empty" className="theater-card rounded-2xl p-8 text-center max-w-xl mx-auto">
          <Images size={28} className="text-[#F0E8DB]/70 mx-auto mb-3" />
          <p className="text-[#C5B8A8] text-sm">قريباً — لقطات من خشبتنا وخلف الستار.</p>
        </div>
      ) : (
        <div className="relative group" dir="ltr">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0f0807] to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0f0807] to-transparent z-10" />
          <div className="flex gap-4 w-max marquee group-hover:[animation-play-state:paused]" data-testid="gallery-strip">
            {[...loop, ...loop].map((g, i) => (
              <button
                key={`${g.id}-${i}`}
                type="button"
                data-testid={i < sorted.length ? `gallery-item-${g.id}` : undefined}
                onClick={() => setActive(g)}
                className="relative h-48 sm:h-60 w-72 sm:w-96 shrink-0 rounded-2xl overflow-hidden border border-[#F0E8DB]/15 hover:border-[#F0E8DB]/60 transition-colors"
              >
                <img src={fileUrl(g.image_url)} alt={g.caption || "صورة"} className="w-full h-full object-cover" loading="lazy" />
                {g.caption && <div dir="rtl" className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent px-3 py-2 text-[#F0E8DB] text-xs text-right">{g.caption}</div>}
              </button>
            ))}
          </div>
        </div>
      )}

      {active && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <button data-testid="gallery-lightbox-close" className="absolute top-4 right-4 text-[#F0E8DB] hover:opacity-70" onClick={() => setActive(null)}><X size={28} /></button>
          <figure className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={fileUrl(active.image_url)} alt={active.caption || ""} className="w-full max-h-[80vh] object-contain rounded-2xl" />
            {active.caption && <figcaption className="text-center text-[#C5B8A8] text-sm mt-3">{active.caption}</figcaption>}
          </figure>
        </div>
      )}
    </section>
  );
}
